import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ScrollText, UserCog, Trash2, Crown, FileText } from "lucide-react";

function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const actionMeta = {
  role_change: { icon: UserCog, label: "Changement de rôle", color: "#60A5FA" },
  delete_player: { icon: Trash2, label: "Suppression joueur", color: "#DC2626" },
  transfer_admin: { icon: Crown, label: "Transfert DT", color: "#E5B85C" },
  match_sheet: { icon: FileText, label: "Feuille de match", color: "#94A3B8" },
};

export default function Audit() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/audit");
        setEntries(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-[11px] font-mono-stat uppercase tracking-[0.25em] text-slate-500 mb-2">
          Traçabilité
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl uppercase tracking-tight flex items-center gap-3">
          <ScrollText className="w-10 h-10 text-[#E5B85C]" />
          Journal des actions
        </h1>
      </div>

      {loading ? (
        <div className="text-slate-400 text-sm font-mono-stat uppercase">Chargement...</div>
      ) : entries.length === 0 ? (
        <div className="p-8 rounded-2xl border border-dashed border-white/10 text-center text-slate-500">
          Aucune action enregistrée pour l'instant
        </div>
      ) : (
        <div className="rounded-2xl bg-slate-900 border border-white/10 overflow-hidden">
          <div className="divide-y divide-white/5">
            {entries.map((e) => {
              const meta = actionMeta[e.action] || {
                icon: FileText,
                label: e.action,
                color: "#94A3B8",
              };
              const Icon = meta.icon;
              return (
                <div
                  key={e.id}
                  data-testid={`audit-${e.id}`}
                  className="p-4 flex items-start gap-4"
                >
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
                    style={{ background: `${meta.color}20` }}
                  >
                    <Icon className="w-4 h-4" style={{ color: meta.color }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-sm">
                      <span style={{ color: meta.color }}>{meta.label}</span>
                      {e.target_name && (
                        <span className="text-slate-400"> · {e.target_name}</span>
                      )}
                    </div>
                    {e.detail && (
                      <div className="text-xs text-slate-400 mt-1">{e.detail}</div>
                    )}
                    <div className="text-[10px] font-mono-stat uppercase tracking-widest text-slate-500 mt-1">
                      Par {e.actor_name || "—"} · {formatDate(e.created_at)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
